import React from "react";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";

import styles from "./ui.module.css";

const IconInput = ({
  label,
  type,
  name,
  onInputChange,
  inputValue,
  handleBlur,
  errors,
  touched,
  iconName,
  required,
  ...props
}) => {
  return (
    <div className={styles.formGroup}>
      {label && (
        <label htmlFor={name} className={styles.label}>
          {label}
          {required && <span className="text-red-500">*</span>}
        </label>
      )}
      <span>
        {iconName ? (
          <IconField iconPosition="left">
            <InputIcon className={iconName} />
            <InputText
              size="large"
              type={type}
              name={name}
              id={name}
              onChange={onInputChange}
              onBlur={handleBlur}
              value={inputValue}
              required={required}
              className={`${errors && touched && "p-invalid"} ${
                props.disabled && styles.disabledTextInput
              }`}
              placeholder={`Enter ${label}`}
              {...props}
            />
          </IconField>
        ) : (
          <InputText
            size="large"
            type={type}
            name={name}
            id={name}
            onChange={onInputChange}
            onBlur={handleBlur}
            value={inputValue}
            required={required}
            className={`${errors && touched && "p-invalid"} ${
              props.disabled && styles.disabledTextInput
            }`}
            placeholder={`Enter ${label}`}
            {...props}
          />
        )}
        {errors && touched && <small className={styles.errors}>{errors}</small>}
      </span>
    </div>
  );
};

export default IconInput;
